export function castToInteger(value, defaultValue = 0) {
    return parseInt(value, 10) || defaultValue;
}
